import { Heading, VStack, Text, Link } from '@chakra-ui/react';
import { FC } from 'react';
import { GetFAQResponse } from '@frx/frx-services';
import parse from 'html-react-parser';
import { Card } from '../../../components';
import styles from './FAQ.module.scss';
import { useEventId } from '../../../hooks';
import { getSjmmw2026FundraisingFaq } from './ShareablesContent';
import {
  diyMosaicLink,
  diyStJudeGraphicLink,
  fitnessResourceLink,
  ironmanResourceLink,
  isDIY,
  isHeroes,
  isIronman,
  isMemphisMarathon,
  isRockNRoll,
} from '../../../utils';

export interface FAQProps {
  faqsData: GetFAQResponse['data']['faqList']['items'];
}

export const FAQ: FC<FAQProps> = ({ faqsData }): JSX.Element => {
  const eventId = useEventId();
  const isFitness =
    isHeroes(String(eventId)) ||
    isMemphisMarathon(String(eventId)) ||
    isRockNRoll(String(eventId));
  const sjmmwFundraisingFaq = getSjmmw2026FundraisingFaq(eventId);

  return (
    <Card w={['full', 'full', '360px']}>
      <Heading size="md" color="brand.primary.swatch1" mb={4}>
        FAQs
      </Heading>
      <VStack spacing={8}>
        {isDIY(String(eventId)) && (
          // stopgap to be removed once AEM APIs fixed
          <>
            <VStack spacing={2} align="stretch">
              <Text fontSize="md" fontWeight="bolder">
                Create your own St. Jude graphic to share with others.
              </Text>
              <Text fontSize="md" className={styles.faqAnswerStyles}>
                <Link href={diyStJudeGraphicLink}>
                  Start building your graphic
                </Link>
              </Text>
            </VStack>

            <VStack spacing={2} align="stretch">
              <Text fontSize="md" fontWeight="bolder">
                Participate in the St. Jude DIY Mosaic.
              </Text>
              <Text fontSize="md" className={styles.faqAnswerStyles}>
                <Link href={diyMosaicLink}>
                  Check out the St. Jude DIY Mosaic
                </Link>
              </Text>
            </VStack>
          </>
        )}

        {faqsData.map(
          (faq, index) =>
            faq.question.trim() && (
              // index as key here since there are no info that can be unique from api
              <VStack key={index} spacing={2} align="stretch">
                <Text fontSize="md" fontWeight="bolder">
                  {faq.question}
                </Text>
                <Text fontSize="md" className={styles.faqAnswerStyles}>
                  {parse(faq.answer.html || '')}
                </Text>
              </VStack>
            )
        )}

        {isIronman(String(eventId)) && (
          // stopgap to be removed once AEM APIs fixed
          <VStack spacing={2} align="stretch">
            <Text fontSize="md" fontWeight="bolder">
              Do you have any training resources available to help prepare for
              the IRONMAN?
            </Text>
            <Text fontSize="md" className={styles.faqAnswerStyles}>
              Yes, training plans are available{' '}
              <Link href={ironmanResourceLink}>here</Link> . You can access
              training plans with a focus on either distance or time.
            </Text>
          </VStack>
        )}

        {isFitness && (
          // stopgap to be removed once AEM APIs fixed
          <VStack spacing={2} align="stretch">
            <Text fontSize="md" fontWeight="bolder">
              Do you have any training resources available to help prepare for
              your race?
            </Text>
            <Text fontSize="md" className={styles.faqAnswerStyles}>
              Yes, training plans are available{' '}
              <Link href={fitnessResourceLink}>here</Link> . You can access
              training plans with a focus on either distance or time.
            </Text>
          </VStack>
        )}

        {sjmmwFundraisingFaq && (
          <VStack spacing={2} align="stretch">
            <Text fontSize="md" fontWeight="bolder">
              <Link href={sjmmwFundraisingFaq.url} download>
                {sjmmwFundraisingFaq.title}
              </Link>
            </Text>
          </VStack>
        )}
      </VStack>
    </Card>
  );
};
